import React, { useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getDollarFormat } from 'utils/helpers';
// Basic Components
import AgGrid from 'screens/components/advanced/AgGrid';
import Button from 'screens/components/basic/Button';

const BranchSummary = ({ rows }) => {
    // Local State
    const [showBranchSummary, setShowBranchSummary] = useState(false);
    
    const dollarSignCell = ({ value }) => <span>{getDollarFormat(value)}</span>;

    const columnsHeader =  [
        { headerName: "Branch", field: "branchName", sortable: true, width: 200 },
        { headerName: "Manual", field: "manual", sortable: true, width: 100, cellRenderer: dollarSignCell },
        { headerName: "Customized", field: "customized", sortable: true, width: 150, cellRenderer: dollarSignCell },
        { headerName: "Campaign", field: "campaign", sortable: true, width: 100, cellRenderer: dollarSignCell },
        { headerName: "Loyalty", field: "loyalty", sortable: true, width: 100, cellRenderer: dollarSignCell }
    ];

    return  (
        <div className="row">
            <Button
                name="showBranchSummary"
                label="Show Summary By Branch"
                icon={<VisibilityIcon />}
                backgroundColor="#9683E5"
                labelStyle={{ color: "white" }}
                className="mb-2"
                primary={true}
                hoverColor="#b09ff5"
                onTouchTap={() => setShowBranchSummary(!showBranchSummary)}
            />
            {showBranchSummary &&
                <AgGrid columns={columnsHeader} rows={rows} />
            }
        </div>
    )
}

export default BranchSummary;


